import { Modal } from 'antd';
import React from 'react';

import { camelCaseToSpacedString } from '../../../../shared/utility';

const WHITE_LIST = [
  'ReleaseName',
  'ReleasePath',
  'ReleaseDate',
  'ReleaseOwner',
  'ReleaseSetupCommand',
  'ReleaseKnownIssues',
  'ReleaseWhatsNew',
];

const ActionDetails = props => {
  const { rowData } = props;

  const renderRowData = () => {
    if (!rowData) {
      return <></>;
    }
    return Object.keys(rowData).map(key => {
      if (!WHITE_LIST.includes(key)) {
        return <></>;
      }
      return (
        <div key={key} className="category-wrapper">
          <label className="category-field">
            {camelCaseToSpacedString(key)}: {rowData[key]}
          </label>
        </div>
      );
    });
  };

  return (
    <Modal
      className="release-notes-modal"
      title="Release Details"
      width="40%"
      open={true}
      destroyOnClose={true}
      onCancel={() => {
        props.onCancel();
      }}
      footer={false}
    >
      <div key="release-modal-details" className="release-notes-modal-content">
        {renderRowData()}
      </div>
    </Modal>
  );
};

export default ActionDetails;
